import { checkPermission } from "@ROM/Permissions/utils";

export const canAccessWarehousesInCompanyAdmin = (user) => checkPermission(user, "company:admin:warehouses");

export const canListWarehouses = (user) => checkPermission(user, "warehouses:index");
export const canCreateWarehouses = (user) => checkPermission(user, "warehouses:create");
export const canEditWarehouses = (user) => checkPermission(user, "warehouses:update");
export const canDeleteWarehouses = (user) => checkPermission(user, "warehouses:delete");
